import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { setTimeSince } from '../../actions/userActions';

@connect((store) => {
    return { dayBefore: store.meta.dayBeforeString, gender: store.user.gender };
})
class TimeSince extends React.Component {
    setTimeSince(value) {
        var currentDate = new Date();
        var dateSince = new Date();
        dateSince.setDate(dateSince.getDate()-value);
        var hours = Math.abs(currentDate - dateSince) / 36e5;

        this.props.dispatch(setTimeSince(hours));

        if (hours < 72) {
            if (this.props.gender === 'female') {
                this.props.history.push('/female');
            } else {
                this.props.history.push('/male');
            }
        } else {
            this.props.history.push('/over72hours');
        }
    }
    
    render() {
        return (
            <div>
                <div className="row justify-content-md-center">
                    <div className="col-md-6">
                        <p className="ec__font__body text-center">
                            Most types of EC should be taken
                            <span className="ec__font__body--blue"> within 3 days </span>
                            of unprotected sex or contraceptive failure <br/> <span className="ec__font__body--small"><i>(condom break, forgot to take the pill, etc)</i></span>.
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col text-center">
                        <h1 className="ec__font__title">Roughly when did it happen?</h1>
                    </div>
                </div>
                <div className="choices row">
                    <div className="col text-center">
                        <button className="ec__button" onClick={this.setTimeSince.bind(this, 0)}>Today</button>
                    </div>
                    <div className="col text-center">
                        <button className="ec__button" onClick={this.setTimeSince.bind(this, 1)}>Yesterday</button>
                    </div>
                    <div className="w-100 d-block d-lg-none"></div>
                    <div className="col text-center">
                        <button className="ec__button" onClick={this.setTimeSince.bind(this, 2)}>{this.props.dayBefore}</button>
                    </div>
                    <div className="col text-center">
                        <button className="ec__button" onClick={this.setTimeSince.bind(this, 3)}>Before {this.props.dayBefore}</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default TimeSince;


// WEBPACK FOOTER //
// ./src/components/screens/TimeSince.js